import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import {getRequest} from "@/api/api";

// import { BASEURL,IMGURL } from '@/api/baseUrl'

/* 播放器 begin-  */
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(VideoPlayer)
Vue.use(ElementUI)
/* 播放器 -end  */

// 定义全局方法
Vue.prototype.getRequest = getRequest;
Vue.prototype.showEditIcon = function (param){
	// this.hidden_menu_edit_icon = '';						// 菜单的编辑按钮：打开就隐藏，注释就显示;默认值：'hidden-menu-edit-icon'
	// this.show_edit_icon = 'show-edit-icon'					// 除菜单外的编辑按钮：'show-edit-icon' ：显示；其他值：隐藏（默认）
	// return
	if(this.$route.query.showEditIcon){
		this.hidden_menu_edit_icon = '';						// 菜单的编辑按钮：打开就隐藏，注释就显示;默认值：'hidden-menu-edit-icon'
		this.show_edit_icon = 'show-edit-icon'					// 除菜单外的编辑按钮：'show-edit-icon' ：显示；其他值：隐藏（默认）
		return
	}
	if(param){
		this.hidden_menu_edit_icon = '';						// 菜单的编辑按钮：打开就隐藏，注释就显示;默认值：'hidden-menu-edit-icon'
		this.show_edit_icon = 'show-edit-icon'					// 除菜单外的编辑按钮：'show-edit-icon' ：显示；其他值：隐藏（默认）
	}
}

// 定义全局变量
Vue.prototype.$globalConfigApiHost 	= process.env.VUE_APP_BACK_SERVER;
Vue.prototype.$globalConfigFileHost = process.env.VUE_APP_IMGURL;
Vue.prototype.$sysFlag 				= process.env.VUE_APP_SYS_FLAG;

// Vue.prototype.$globalConfigApiHost = BASEURL;
// Vue.prototype.$globalConfigFileHost = IMGURL;

// Vue.prototype.$globalConfigApiHost = 'http://43.138.142.170:18081';
// Vue.prototype.$globalConfigFileHost = 'http://43.138.142.170:18081';

// Vue.prototype.$globalConfigApiHost = 'http://localhost:18081';
// Vue.prototype.$globalConfigFileHost = 'http://localhost:18081';
Vue.prototype.hidden_menu_edit_icon	= 'hidden-menu-edit-icon';	// 菜单的编辑按钮：打开就隐藏，注释就显示；默认值：'hidden-menu-edit-icon'
Vue.prototype.show_edit_icon 		= '';								// 除菜单外的编辑按钮：'show-edit-icon' ：显示；其他值：隐藏（默认）


Vue.config.productionTip = false;

/* 地图组件 */
// import VueBaiduMap from 'vue-baidu-map'
// Vue.use(VueBaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'GtvRaT8YSaCvrSEXWLv5obmq'  // MAP_APP_KEY
// })


// console.log("环境", 		process.env.NODE_ENV)
// console.log("服务端", 	process.env.VUE_APP_SERVER)
// console.log("系统id", 	process.env.VUE_APP_SYS_FLAG)
// console.log("配置变量AMAP_KEY ", process.env.VUE_APP_AMAP_KEY)
// console.log("配置变量securityJsCode ", process.env.VUE_APP_AMAP_SECURITY_JS_CODE_QUERY)


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
